"use strict";

import {onFind} from "./elements-packages/init-modules-in-scope";
import {on, closest} from "@elements/dom-utils";

const selectors = {
    base: '.js-nav-tracking',
    link: '.js-nav-tracking__link'
};

export function init() {
    onFind(selectors.base, function (navOverlay) {
        on('click', function (evt) {
            const link = closest(selectors.link, evt.target);
            if (!link) return;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'click_main_navigation',
                'main_item': link.dataset.navTrackingMain || '',
                'sub_item': link.dataset.navTrackingSub || '',
                'selected_item': link.dataset.navTrackingSelected || ''
            });
        }, navOverlay);
    });
}
